import { IUpdateBreakpoint, NavigationActionKind } from './types'
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints'

export const updateBreakpoint = (breakpoint: Breakpoint): IUpdateBreakpoint => ({
  type: NavigationActionKind.UpdateBreakpoint,
  payload: { breakpoint }
})
